import '@assets/css/Admin/components/table.scss';
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/styles';
import { apiClient } from '@services/api';
import * as React from 'react';
import { useHistory, useRouteMatch } from "react-router-dom";

// Skeleton shimmer overlay exibido enquanto a tabela carrega dados
const skeletonKeyframes = `
  @keyframes ft-shimmer {
    0%   { background-position: -600px 0; }
    100% { background-position:  600px 0; }
  }
`;

function SkeletonRow({ columns }) {
  const widths = columns?.length
    ? columns.map(c => c.width || c.minWidth || (c.flex ? 160 : 120))
    : [200, 150, 150, 150, 150];

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: 52, padding: '0 10px', borderBottom: '1px solid #162d4a' }}>
      {widths.map((w, i) => (
        <div key={i} style={{ flex: columns?.[i]?.flex || 'none', minWidth: w, width: w, paddingRight: 16 }}>
          <div style={{
            height: 14,
            borderRadius: 7,
            background: 'linear-gradient(90deg, #1a3a5c 25%, #234d7a 50%, #1a3a5c 75%)',
            backgroundSize: '600px 100%',
            animation: 'ft-shimmer 1.4s infinite linear',
          }} />
        </div>
      ))}
    </div>
  );
}

function SkeletonOverlay({ columns }) {
  return (
    <>
      <style>{skeletonKeyframes}</style>
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        background: '#0f2340',
        zIndex: 4,
        overflow: 'hidden',
      }}>
        {[...Array(10)].map((_, i) => (
          <SkeletonRow key={i} columns={columns} />
        ))}
      </div>
    </>
  );
}


const exmp = {
  "current_page": 1,
  "data": [],
  "first_page_url": "http://127.0.0.1:8000/api/service_integrations?page=1",
  "from": 1,
  "last_page": 1,
  "last_page_url": "http://127.0.0.1:8000/api/service_integrations?page=1",
  "links": [
    {
      "url": null,
      "label": "&laquo; Anterior",
      "active": false
    },
    {
      "url": "http://127.0.0.1:8000/api/service_integrations?page=1",
      "label": "1",
      "active": true
    },
    {
      "url": null,
      "label": "Próximo &raquo;",
      "active": false
    }
  ],
  "next_page_url": null,
  "path": "http://127.0.0.1:8000/api/service_integrations",
  "per_page": "30",
  "prev_page_url": null,
  "to": 2,
  "total": 2
}

function loadServerRows(path, page, pageSize, params, signal) {
  return apiClient.httpInstance.get(path, {
    params: {
      ...params,
      pageSize,
      page
    },
    signal,
  }).then(response => {
    if (response.status === 200) {
      if (path === '/companys_integrations') {
        const total = exmp;
        total.data = response.data;
        return total;
      } else {
        return response.data;
      }
    }
  })
    .catch((error) => {
      // Ignora cancelamentos — são intencionais ao trocar de busca
      if (error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError') return null;
      console.log(error);
    });
}

const useStyles = makeStyles({
  root: {
    '& .super-app-theme--header': {
      fontWeight: 'bold',
      fontFamily: 'Poppins',
      fontSize: '14px',
      color: `${process.env.REACT_APP_SECONDARY_COLOR}`,
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold',
    },
    '& .super-app-theme--cell': {
      color: `${process.env.REACT_APP_SECONDARY_COLOR}`,
      cursor: 'pointer',
      fontFamily: 'Poppins',
      fontSize: '14px',
    },
  },
});

export default function ServerPaginationGrid(props) {
  const { path } = useRouteMatch();
  const [blockClick, setBlockClick] = React.useState(true);
  const columns = props.columns;
  const getPath = props.path;
  const history = useHistory();
  const classes = useStyles();
  const onRowClick = props.onRowClick === undefined ? (param) => {
    if (blockClick) {
      history.push(`${path}/detalhe/${param.id}`);
    }
  } : props.onRowClick;

  const onCellClick = (param, e) => {
    const fields = columns.filter(function (item) {
      if (item?.preventRedirect) {
        return item;
      }
    }).map(function (item) {
      return item.field;
    });

    if (fields.includes(param.field)) {
      e.stopPropagation();
    }
  };

  let params = props.params;
  // Serializar params para comparação estável no useEffect (objeto inline cria nova referência a cada render)
  const paramsKey = JSON.stringify(params);

  const [page, setPage] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(15);
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageHeight, setPageHeight] = React.useState(115)
  // Sinaliza que o efeito de filtro já está tratando a request — evita request dupla no efeito de página
  const filterChangedRef = React.useRef(false);

  const handlePageChange = (params) => {
    if (params && params.page === undefined) {
      setPage(Number(params));
    } else {
      setPage(Number(params.page));

    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    const sizePage = rows.length > newPageSize ? newPageSize : rows.length;
    setPageHeight(rows.length > 0 ? 115 + 52 * sizePage : 300);
  };

  const applyResult = React.useCallback((result, currentPageSize) => {
    const newRows = props?.dataResult
      ? result?.[props.dataResult]?.data ?? result?.data
      : result?.data;
    const newTotal = props?.dataResult ? result?.[props.dataResult]?.total : result?.total;
    setTotal(Number(newTotal) || 0);
    setRows(newRows ?? []);
    const sizePage = (newRows?.length ?? 0) > currentPageSize ? currentPageSize : (newRows?.length ?? 0);
    setPageHeight((newRows?.length ?? 0) > 0 ? 115 + 52 * sizePage : 300);
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.dataResult]);

  // Troca de página/tamanho — disparo imediato, sem debounce
  React.useEffect(() => {
    // Se o filtro acabou de mudar, ele já disparou a request com page=1; não duplicar
    if (filterChangedRef.current) {
      filterChangedRef.current = false;
      return;
    }
    const controller = new AbortController();
    let active = true;

    (async () => {
      setLoading(true);
      const result = props.loadRows
        ? await props.loadRows(getPath, page + 1, pageSize, params)
        : await loadServerRows(getPath, page + 1, pageSize, params, controller.signal);
      if (!active || result === null) return;
      applyResult(result, pageSize);
    })();

    return () => { active = false; controller.abort(); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPath, page, pageSize]);

  // Troca de filtros/busca — debounce 400ms + AbortController para cancelar request anterior
  // Reseta para a página 1 para que o resultado não seja a pág. 3 com o novo filtro
  React.useEffect(() => {
    const controller = new AbortController();
    let active = true;

    filterChangedRef.current = true;
    setPage(0); // reseta paginação — se já era 0, React não re-renderiza e o ref é ignorado

    const timeOutId = setTimeout(async () => {
      setLoading(true);
      const result = props.loadRows
        ? await props.loadRows(getPath, 1, pageSize, params)
        : await loadServerRows(getPath, 1, pageSize, params, controller.signal);
      if (!active || result === null) return;
      applyResult(result, pageSize);
    }, 400);

    return () => { active = false; controller.abort(); clearTimeout(timeOutId); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsKey, getPath]);

  React.useEffect(() => {
    if (params?.pageSize) {
      setPageSize(params?.pageSize);
      setPageHeight(params?.pageSize)
    }
    if (props.refresh === true) {
      const controller = new AbortController();
      let active = true;
      (async () => {
        setLoading(true);
        const result = props.loadRows
          ? await props.loadRows(getPath, page + 1, pageSize, params)
          : await loadServerRows(getPath, page + 1, pageSize, params, controller.signal);
        if (!active || result === null) return;
        applyResult(result, pageSize);
      })();
      return () => { active = false; controller.abort(); };
    }
  // Removido pageSize das dependências: evitava que o usuário trocasse o tamanho
  // da página pois o efeito resetava para params.pageSize a cada mudança
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.refresh, getPath]);

  return (
    <div style={{ overflowX: 'auto', width: '100%', WebkitOverflowScrolling: 'touch' }}>
    <div style={{ background: '#0f2340', height: pageHeight, minWidth: '700px', width: '100%' }} className={classes.root}>
      <DataGrid
        {...props}
        rows={rows}
        columns={columns}
        pagination
        // localeText={ptBR.props.MuiDataGrid.localeText}
        pageSize={pageSize}
        rowCount={total}
        rowsPerPageOptions={[15, 30, 50, 100]}
        disableSelectionOnClick={true}
        getRowClassName={(params) =>
          `super-app-theme--cell`
        }
        onRowClick={onRowClick}
        onCellClick={onCellClick}
        paginationMode="server"
        onPageSizeChange={handlePageSizeChange}
        onPageChange={(params) => { handlePageChange(params) }}
        loading={loading}
        disableColumnMenu
        components={{
          LoadingOverlay: () => <SkeletonOverlay columns={columns} />,
          NoRowsOverlay: () => (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute"
              }}
            >
              Não encontramos resultados para a sua busca.
            </div>
          )
        }}
      />
    </div>
    </div>
  );
}
